module.exports = __webpack_public_path__ + "static/flags/LU-8b9b45f5cd7e3dfbb7cbe2a422e0bae9.gif";